import 'css-chunk:src/feature/provision/ProgressStepper.module.scss';export default {
  "label": "ProgressStepper_label",
  "active": "ProgressStepper_active",
  "completed": "ProgressStepper_completed",
  "connector_line": "ProgressStepper_connector_line"
};